import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, {useState} from "react";
import {toast} from "react-toastify";
import {resetPasswordForm} from "../schema/form";
import {resetPassword} from "../services/dataService";
import CloseIcon from "@mui/icons-material/Close";
import {getUser} from "../services/authService";

const ResetPasswordDialog = ({open, handleClose, setOpen}) => {
  const user = getUser();
  const [resetDetails, setResetDetails] = useState({
    LoginId: user?.userDetails["LoginId"],
    Email: user?.userDetails["Email"],
  });

  const handleReset = (event) => {
    setResetDetails({
      ...resetDetails,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      await resetPassword(resetDetails);
      toast.success("Password successfully updated!");
      setOpen(false);
    } catch (error) {
      toast.error("Unable to update password.");
    }
  };

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Typography variant="h5">Reset Password</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{
            pt: 1
          }}>
            {resetPasswordForm.map((current) => {
              return (
                <Grid item lg={current.wdth} key={current.name}>
                  <TextField
                    fullWidth
                    label={current.label}
                    name={current.name}
                    type={current.type}
                    value={resetDetails[current.name]}
                    disabled={current.disable}
                    onChange={handleReset}
                  />
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResetPasswordDialog;
